// ==========================
//  Helpers
// ==========================
const BOLD_REGEX = /\*\*(.*?)\*\*/g;
const URL_REGEX = /(?<![@\w])(?:https?:\/\/)?(?![\d.]+$)(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/\S*)?/

// ==========================
// Formatters
// ==========================
export const getInitials = (fullName) => {
  if (!fullName) return '';
  return fullName.split(' ').map((w) => w.charAt(0).toUpperCase()).join('').substring(0, 2);
};

export const formatBold = (text) => {
    return text.replace(BOLD_REGEX, "<strong>$1</strong>")
};

export const formatUrls = (text) => {
  return text.replace(URL_REGEX, (url) => {
    const href = url.startsWith("http") ? url : `http://${url}`;
    return `<a href="${href}" target="_blank">${url}</a>`;
  });
};

// ==========================
// Date formatters
// ==========================
export const formatDateTime = (ts) => {
  const date = new Date(ts);
  const now = new Date();

  const dateOnly = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const today = dateOnly(now);
  const yesterday = today - 86400000;
  const compare = dateOnly(date);

  const time = date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

  if (compare === today) return `Hoje, ${time}`;
  if (compare === yesterday) return `Ontem, ${time}`;

  return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}, ${time}`;
};

const MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export const formatDateLabel = (ts) => {
  const date = new Date(ts);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) return "Hoje";
  if (date.toDateString() === yesterday.toDateString()) return "Ontem";

  return `${date.getDate()} de ${MONTHS[date.getMonth()]} de ${date.getFullYear()}`;
};
